import Minus from "../../../assets/minus.svg";
import React, { ChangeEvent } from "react";
import Plus from "../../../assets/plus.svg";
import VectorDash from "../../../assets/vector_dash.svg";
import VectorRight from "../../../assets/vector_right.svg";
import { CheckBox, CheckboxChecked, CheckboxUnchecked, Datepicker, SelectDropdown, TextareaCount } from "./Inputs";
import { Direction } from "../../../types/directions";
import { getTicketTypeIcon, getTicketTypeName } from "../../../helpers/claims";
import { useSelectorsCitiesQuery } from "../../../hooks/useSelectorsQuery";
import { DirectionModel, TicketType } from "../../../types/travelClaims";
import { useTravelClaimModel } from "../../../context/travelClaims";
import { City } from "../../../types/geo";
import { formatDateToYYYYMMDD } from "../../../helpers/dates";
import { includes } from "lodash";

interface DirectionProps {
    onClick?: (value: any) => void
    direction: Direction
    index: number
}

interface DirectionEditProps {
    onClick?: (value: any) => void
    direction: DirectionModel
    readOnly?: boolean
    index?: number
}

interface ChangeProps {
    onChange: (value: any) => void
}

interface DirectionDataProps {
    label?: string | null
    date?: string | null
    ticket_type?: TicketType
    need_baggage?: boolean
    without_hotel?: boolean
}

interface DirectionDataEditProps extends DirectionDataProps, ChangeProps {
    readOnly?: boolean
}


export const AddDirection = ({ onClick }: { onClick: () => void }) => {
    return (
        <div className="px-5 flex flex-col w-full items-start mb-5 gap-5 relative flex-[0_0_auto] mr-[-20.00px]">
            <div className="w-full inline-flex flex-col items-start gap-5 relative flex-[0_0_auto]">
                {/*CONTROLS*/}
                <div className="inline-flex w-full items-center gap-5 relative flex-[0_0_auto]">
                    <div
                        className="relative w-11/12 font-manager-acrom-h3-20-medium-acrom font-[number:var(--manager-acrom-h3-20-medium-acrom-font-weight)] text-black text-[length:var(--manager-acrom-h3-20-medium-acrom-font-size)] tracking-[var(--manager-acrom-h3-20-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-h3-20-medium-acrom-line-height)] [font-style:var(--manager-acrom-h3-20-medium-acrom-font-style)]">
                        Направления
                    </div>
                    <button
                        onClick={onClick}
                        className="relative bg-[#fcd700] w-8 h-8 rounded-lg overflow-hidden">
                        <img alt="" src={Plus} className="!absolute !w-8 !h-8 !top-0 !left-0" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export const EditDirection = () => {
    const {
        model,
        updateModel,
        updateNestedModel,
        addNestedModel
    } = useTravelClaimModel();

    return (
        <div className="px-5 w-full mt-0 flex flex-col justify-start gap-1">
            {model.directions.filter(e => !e.to_delete).map((direction, index) => {
                return <DirectionItemEdit
                    key={index}
                    index={index}
                    // readOnly={!!direction.pk}
                    direction={direction}
                    onClick={() => updateNestedModel(direction.id, { to_delete: true })}
                />
            })}
        </div>
    );
}

export const DateEdit = ({ date, onChange, readOnly, label }: DirectionDataEditProps) => {
    return (
        <div className="w-full inline-flex flex-col items-start gap-2 relative flex-[0_0_auto]">
            <label
                className="w-full text-[#949494] text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)] leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)] font-manager-acrom-ph-14-medium-acrom font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]">
                {label ? label : 'Дата'}
            </label>
            <div
                className="w-full inline-flex items-center relative flex-[0_0_auto] bg-[#f2f2f2] rounded-lg overflow-hidden">
                <Datepicker
                    readOnly={readOnly}
                    date={date}
                    onDateChange={onChange}
                />
            </div>
        </div>
    )
}

export const Baggage = ({ ticket_type, need_baggage }: DirectionDataProps) => {
    if (!['', 'ANY', 'AVIA'].includes(ticket_type ?? '')) {
        return <div></div>
    }
    return (
        <div className="inline-flex items-center gap-2.5 relative flex-[0_0_auto]">
            {need_baggage ? <CheckboxChecked /> : <CheckboxUnchecked />}
            <div
                className="relative w-16 text-black font-manager-acrom-ph1-16-medium-acrom font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                Багаж
            </div>
        </div>
    )
}

export const WithoutHotel = ({ without_hotel }: DirectionDataProps) => {
    return (
        <div className="inline-flex flex-row  items-center gap-2.5 relative flex-[0_0_auto]">
            {without_hotel ? <CheckboxChecked /> : <CheckboxUnchecked />}
            <div
                className="relative w-auto text-black font-manager-acrom-ph1-16-medium-acrom font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                Отель не нужен
            </div>
        </div>
    )
}

export const DirectionItem = ({ direction, index }: DirectionProps) => {
    return (
        <div
            className="flex flex-col w-full items-start gap-5 p-5 relative flex-[0_0_auto] bg-white rounded-lg overflow-hidden shadow-shadow-card">
            <div className="inline-flex flex-col w-full items-start gap-1 relative flex-[0_0_auto]">
                <div className="w-full flex-col inline-flex items-start gap-1 relative flex-[0_0_auto]">
                    <div>
                        Направление-{index ? index + 1 : 1}
                    </div>
                    <div className="font-bold">
                        {direction.start_city?.name} {direction.destination_city?.name ? `- ${direction.destination_city?.name}` : ''}
                    </div>
                </div>
                <div
                    className="relative w-full text-[#949494] font-client-acrom-ph1-16-medium-acrom font-[number:var(--client-acrom-ph1-16-medium-acrom-font-weight)] text-[length:var(--client-acrom-ph1-16-medium-acrom-font-size)] tracking-[var(--client-acrom-ph1-16-medium-acrom-letter-spacing)] leading-[var(--client-acrom-ph1-16-medium-acrom-line-height)] [font-style:var(--client-acrom-ph1-16-medium-acrom-font-style)]">
                    {getTicketTypeName(direction.ticket_type)}
                </div>
            </div>
            <div className="inline-flex flex-col  w-full items-start relative flex-[0_0_auto]">
                <div className="inline-flex flex-row w-full h-8">
                    <div className="inline-flex w-full justify-between">
                        <div
                            className="relative min-w-24 w-1/3 font-manager-acrom-ph1-16-medium-acrom font-bold text-black text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                            {direction.start_date && new Date(direction.start_date).toLocaleDateString()}
                        </div>
                        <div className="inline-flex min-w-28 w-1/3 items-center relative flex-[0_0_auto]">
                            <img alt="" src={getTicketTypeIcon(direction.ticket_type)} className="!relative !w-6 !h-6" />
                            <div
                                className="w-full min-w-24 flex flex-row justify-center overflow-hidden items-center h-1.5">
                                <div className="!w-1.5 !h-1.5 bg-black rounded-[3px]" />
                                <div className="flex flex-row overflow-hidden justify-center items-center">
                                    <img alt="" src={VectorRight} className="!object-cover" />
                                    {direction.end_date ?
                                        <img alt="" src={VectorRight} className="!object-cover rotate-180" /> :
                                        <img alt="" src={VectorDash} className="!h-px !object-cover" />
                                    }
                                </div>
                                <div className="!w-1.5 !h-1.5 bg-black rounded-[3px]" />
                                {/*<div className="!w-1.5 !h-1.5 rounded-[3px] border border-solid border-[#282828]"/>*/}
                            </div>
                        </div>
                        <div
                            className="relative min-w-24 w-1/3 text-right font-manager-acrom-ph1-16-medium-acrom font-bold text-black text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                            {direction.end_date && new Date(direction.end_date).toLocaleDateString()}
                        </div>
                    </div>
                    {/*<div*/}
                    {/*    className="w-1/3 inline-flex align-middle justify-end items-center text-black text-right font-manager-acrom-ph1-16-medium-acrom font-bold text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">*/}
                    {/*    {direction.start_city && direction.start_city.name} - {direction.destination_city && direction.destination_city.name}*/}
                    {/*</div>*/}
                </div>
                <Baggage need_baggage={direction.need_baggage} ticket_type={direction.ticket_type} />
            </div>
            {!direction.hotel_wishes && <WithoutHotel without_hotel={direction.without_hotel} />}
            <div className="flex w-full gap-1 relative flex-[0_0_auto] flex-col items-start">
                <div
                    className="relative w-full text-[#949494] font-manager-acrom-ph1-16-medium-acrom font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                    Комментарии
                </div>
                <div
                    className="relative w-full font-manager-acrom-ph1-16-medium-acrom font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] text-black text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                    {direction.hotel_wishes}
                </div>
            </div>
        </div>
    );
};

export const DirectionItemEdit = ({ direction, index, onClick, readOnly }: DirectionEditProps) => {
    const {
        updateNestedModel,
    } = useTravelClaimModel();

    const handleTicketType = (type: TicketType) => {
        if (readOnly) {
            return
        }
        // Обновляем вложенную модель под нужным ID
        updateNestedModel(direction.id, { ticket_type: type })
        if (!['', 'ANY', 'AVIA'].includes(type)) {
            updateNestedModel(direction.id, { need_baggage: false })
        }
    }

    const handleHotelWishes = (e: ChangeEvent<HTMLTextAreaElement>) => {
        if (readOnly) {
            return
        }
        if (e.target.value.length <= 500) {
            updateNestedModel(direction.id, { hotel_wishes: e.target.value })
        }
    };

    const handleSelectStartChange = (value: City) => {
        if (readOnly) {
            return
        }
        updateNestedModel(direction.id, { start_city: value })
    };

    const handleSelectDestinationChange = (value: City) => {
        if (readOnly) {
            return
        }
        updateNestedModel(direction.id, { destination_city: value })
    };

    const handleStartDate = (date: string) => {
        if (readOnly) {
            return
        }
        let resultDate = date;
        if (date && date.length) {
            // Дата начала не может быть меньше текущей даты
            const nowDate = new Date();
            const currentDate = new Date(date);
            if (currentDate < nowDate) {
                resultDate = formatDateToYYYYMMDD(nowDate)
            }
            // Если ранее была установлена дата окончания и она меньше выбранной даты начала
            if (direction.end_date) {
                const endDate = new Date(direction.end_date);
                if (currentDate > endDate) {
                    updateNestedModel(direction.id, { end_date: resultDate })
                }

            }
        }

        updateNestedModel(direction.id, { start_date: resultDate })
    }

    const handleEndDate = (date: string | null) => {
        if (readOnly) {
            return
        }
        let resultDate = date;
        if (date && date.length) {
            // Дата окончания не может быть меньше текущей даты и даты начала
            const nowDate = new Date();
            const currentDate = new Date(date);
            if (currentDate < nowDate) {
                resultDate = formatDateToYYYYMMDD(nowDate)
            }
            // Если ранее была установлена дата начала и она выбранная дата окончания меньше даты начала
            if (direction.start_date) {
                const startDate = new Date(direction.start_date);
                if (currentDate < startDate) {
                    resultDate = formatDateToYYYYMMDD(startDate)
                }

            }
        }
        updateNestedModel(direction.id, { end_date: resultDate })
    }

    const handleWithoutHotel = (value: boolean) => {
        if (readOnly) {
            return
        }
        if (value) {
            // Если отель не нужен, то очищаем пожелания по отелю
            updateNestedModel(direction.id, { hotel_wishes: '' })
        }
        updateNestedModel(direction.id, { without_hotel: value })
    }

    const handleNeedBaggage = (value: boolean) => {
        if (readOnly) {
            return
        }
        updateNestedModel(direction.id, { need_baggage: value })
    }

    return (
        <div className="w-full inline-flex mb-4 flex-col items-start gap-5 relative flex-[0_0_auto]">
            <div className="relative w-full h-px bg-line" />
            <div className="flex flex-col w-full items-start gap-5 relative flex-[0_0_auto]">
                <div className="w-full inline-flex items-center gap-5 relative flex-[0_0_auto]">

                    <div
                        className="relative w-11/12 text-black text-[length:var(--manager-acrom-h2-18-medium-acrom-font-size)] leading-[var(--manager-acrom-h2-18-medium-acrom-line-height)] font-manager-acrom-h2-18-medium-acrom font-[number:var(--manager-acrom-h2-18-medium-acrom-font-weight)] tracking-[var(--manager-acrom-h2-18-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-h2-18-medium-acrom-font-style)]">
                        <div>
                            Направление-{index ? index + 1 : 1}
                        </div>
                        <div className="font-bold">
                            {direction.start_city?.name} {direction.destination_city?.name ? `- ${direction.destination_city?.name}` : ''}
                        </div>
                    </div>
                    <button
                        onClick={onClick}
                        className="bg-[#f2f2f2] relative w-8 h-8 rounded-lg overflow-hidden">
                        <img className="!absolute !w-6 !h-6 !top-[3px] !left-[3px]" alt="" src={Minus} />
                    </button>
                </div>
                <div className="w-full inline-flex flex-col items-start gap-5 relative flex-[0_0_auto]">
                    <div className="w-full inline-flex flex-col items-start gap-5 relative flex-[0_0_auto]">
                        <div className="w-full inline-flex flex-col items-start gap-2.5 relative flex-[0_0_auto]">
                            <div className="w-full inline-flex justify-between items-start relative flex-[0_0_auto]">
                                <div
                                    className="w-[49%] inline-flex flex-col items-start gap-2 relative flex-[0_0_auto]">
                                    <div
                                        className="w-full relative mt-[-1.00px] text-[#949494] text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)] leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)] font-manager-acrom-ph-14-medium-acrom font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]">
                                        Откуда
                                    </div>
                                    <SelectDropdown
                                        readOnly={readOnly}
                                        onChange={handleSelectStartChange}
                                        fetchDataFunc={useSelectorsCitiesQuery}
                                        selected={direction.start_city}
                                    />
                                    <DateEdit
                                        label={'Дата - туда'}
                                        readOnly={readOnly}
                                        date={direction.start_date}
                                        onChange={handleStartDate}
                                    />
                                </div>
                                <div
                                    className="w-[49%] inline-flex flex-col items-start gap-2 relative flex-[0_0_auto]">
                                    <div
                                        className="relative w-full mt-[-1.00px] text-[#949494] text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)] leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)] font-manager-acrom-ph-14-medium-acrom font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]">
                                        Куда
                                    </div>
                                    <SelectDropdown
                                        readOnly={readOnly}
                                        onChange={handleSelectDestinationChange}
                                        fetchDataFunc={useSelectorsCitiesQuery}
                                        selected={direction.destination_city}
                                    />
                                    <DateEdit
                                        label={'Дата - обратно'}
                                        readOnly={readOnly}
                                        date={direction.end_date}
                                        onChange={handleEndDate}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="w-full inline-flex items-start gap-5 relative flex-[0_0_auto]">
                            <div className="w-[49%] inline-flex flex-col items-start gap-2.5 relative flex-[0_0_auto]">
                                <div className="relative w-full min-h-8 flex flex-col gap-2.5 ">
                                    <div className="flex w-full items-center gap-2.5 min-h-8">
                                        <CheckBox
                                            checked={direction.ticket_type === 'AVIA'}
                                            onChange={() => handleTicketType('AVIA')}
                                        />
                                        <div
                                            className="relative w-full text-black text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] font-manager-acrom-ph1-16-medium-acrom font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                                            Авиабилеты
                                        </div>
                                    </div>
                                    {
                                        direction.ticket_type === 'AVIA' && (
                                            <div
                                                className="flex w-full min-h-8 items-center gap-2.5 ml-8">
                                                <CheckBox
                                                    checked={direction.need_baggage ?? false}
                                                    onChange={handleNeedBaggage} />
                                                <div
                                                    className="w-3/4 font-manager-acrom-ph1-16-medium-acrom font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] text-black text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                                                    Нужен багаж
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                                <div className="flex w-full items-center gap-2.5 min-h-8 flex-[0_0_auto]">
                                    <CheckBox
                                        checked={direction.ticket_type === 'TRAIN'}
                                        onChange={() => handleTicketType('TRAIN')} />
                                    <div
                                        className="relative w-full text-black text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] font-manager-acrom-ph1-16-medium-acrom font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                                        Ж/Д билеты
                                    </div>
                                </div>
                            </div>
                            <div className="w-[49%] inline-flex flex-col items-start gap-2.5 relative flex-[0_0_auto]">
                                <div className="flex w-full items-center gap-2.5 min-h-8 flex-[0_0_auto]">
                                    <CheckBox
                                        checked={direction.ticket_type === 'BUS'}
                                        onChange={() => handleTicketType('BUS')} />
                                    <div
                                        className="relative w-full text-black text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] font-manager-acrom-ph1-16-medium-acrom font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                                        Автобус
                                    </div>
                                </div>
                                <div className="relative w-full min-h-8 flex flex-col gap-2.5 ">
                                    <div className="flex w-full items-center gap-2.5 min-h-8 ">
                                        <CheckBox
                                            checked={['', 'ANY'].includes(direction.ticket_type)}
                                            onChange={() => handleTicketType('ANY')}
                                        />
                                        <div
                                            className="text-black text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] font-manager-acrom-ph1-16-medium-acrom font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                                            Любой
                                        </div>
                                    </div>

                                    {
                                        ['', 'ANY'].includes(direction.ticket_type) && (
                                            <div
                                                className="flex w-full min-h-8 items-center gap-2.5 ml-8">
                                                <CheckBox
                                                    checked={direction.need_baggage ?? false}
                                                    onChange={handleNeedBaggage} />
                                                <div
                                                    className="w-3/4 font-manager-acrom-ph1-16-medium-acrom font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] text-black text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                                                    Нужен багаж
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="w-full inline-flex flex-col items-start gap-5 relative flex-[0_0_auto]">
                <div className="w-full inline-flex flex-col items-start gap-2.5 relative flex-[0_0_auto]">
                    <div className="w-full inline-flex flex-col items-start gap-2 relative flex-[0_0_auto]">
                        <div
                            className="relative w-full mt-[-1.00px] text-[#949494] text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)] leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)] font-manager-acrom-ph-14-medium-acrom font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]">
                            Отель
                        </div>
                        <div
                            className="flex w-full items-start gap-2.5 px-4 py-3.5 relative flex-[0_0_auto] bg-[#f2f2f2] rounded-lg overflow-hidden">
                            <TextareaCount
                                readOnly={direction.without_hotel || readOnly}
                                text={direction.hotel_wishes ?? ''}
                                handleChange={handleHotelWishes}
                                placeholder={'Напишите пожелания по отелю'} />
                        </div>
                    </div>
                    <div className="w-full inline-flex items-center gap-2.5 relative flex-[0_0_auto]">
                        <CheckBox
                            checked={direction.without_hotel ?? false}
                            onChange={handleWithoutHotel} />
                        <div
                            className="relative w-1/2 text-black text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] font-manager-acrom-ph1-16-medium-acrom font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                            Отель не нужен
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
